import { Component, Input, OnInit, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { AuthenticationService, Logger } from '@app/core';
import { Base, BaseControl, ConfirmComponent, Const, Modal, ParametroFiltro} from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { ReportFilterDataService } from './shared/report-filter.data.service';
import { ReportFilterFormService } from './shared/report-filter.form.service';
import { ReportFilterConfigService } from './shared/report-filter.config.service';
import { Opcion } from '../../../../shared/util/static';
import { Option } from '../../../../shared/dynamic-form/shared/controls/dropdown';


const log = new Logger('CreationDynamicComponentComponent');

@Component({
  selector: 'iw-report-filter',
  templateUrl: './report-filter.component.html',
  styleUrls: ['./report-filter.component.scss'],
  providers: [
    ReportFilterDataService,
    ReportFilterFormService
  ]
})
export class ReportFilterComponent implements OnInit {
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  settings = {};
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    update: false,
    delete: false
  };
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Define si el filtro seleccionado esta en edicion
  filterEdit = true;
  // define el filtro seleccionado
  filterSelected: ParametroFiltro;
  // Datos para llenar la tabla
  @Input() sourceData: ParametroFiltro[] = [];
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;

  // Lista de tipos de campos
  typeOptions: any[] = [];
  // Lista de modales
  typeModals: any[] = [];
  // Contiene el id del reporte seleccionado
  @Input() idReport = -1;

  constructor(
    private toastr: ToastrService,
    private as: AuthenticationService,
    private rfds: ReportFilterDataService,
    private rffs: ReportFilterFormService
  ) { }

  ngOnInit() {
    // Determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationReports,
      Const.types_action_permissions.created
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationReports,
      Const.types_action_permissions.update
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationReports,
      Const.types_action_permissions.delete
    );
    const configTable = new ReportFilterConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineActionCondictions(res.action, res.data);
    });
    this.rfds.getTypeField().subscribe( resp => {
      resp.forEach(tf => {
        this.typeOptions.push({value: tf.id, key: tf.nombre});
      });
    });
    this.rfds.getModals().subscribe( res => {
      res.forEach(tm => {
        this.typeModals.push({value: tm.id, key: tm.nombre });
      });
    });
    this.loadfilters();
  }

  /**
   * consulta los filtros por el id del reporte
   *
   * @memberof ReportFilterComponent
   */
  loadfilters() {
    this.rfds.getFilters(this.idReport).subscribe(res => {
      if(res.length){
        res.forEach(r => {
          r['tipo_campo_nombre'] = r.tipo_campo.nombre;
        });
        this.sourceData = res;
      }
    });
  }


  /**
   * Define las acciones ha realizar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ReportFilterComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        if (this.activateAction.created) {
          this.formOpen = true;
          this.filterEdit = false;
          this.actionForm = 'Agregar';
          this.controls = this.rffs.getFormFilter(this.ngSelectTpl, this.typeOptions, this.typeModals );
        } else {
          this.toastr.error('Usted no posee permisos para agregar filtros',
            'Permiso denegado');
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          this.formOpen = true;
          this.filterEdit = true;
          this.actionForm = 'Modificar';
          this.filterSelected = data;
          this.controls = this.rffs.getFormFilter(
            this.ngSelectTpl,  this.typeOptions, this.typeModals, this.filterSelected);
        } else {
          this.toastr.error('Usted no posee permisos para modificar el filtro',
            'Permiso denegado');
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.filterSelected = data;
          this.question = '¿Realmente desea eliminar el filtro?';
          this.confirm.open();
        } else {
          this.toastr.error('Usted no posee permisos para eliminar el filtro',
            'Permiso denegado');
        }
        break;
    }
  }

  /**
   * Metodo que organiza el filtro y lo modifica
   *
   * @param {*} data
   * @memberof DocumentClassificationComponent
   */
  sended(data: any) {
    const fil: ParametroFiltro = {
      label: data.txtLabel,
      alias: data.txtAlias,
      alias_subconsulta: data.txtAliasSubconsulta,
      orden: data.txtOrden,
      campo: JSON.parse(data.txtCampo),
      espacio: data.txtEspacio,
      requerido: data.chRequerido,
      filtro_subconsulta: data.chFiltroSubconsulta,
      tipo_campo: data.cboTipoCampo,
      sistema: data.chSistema,
      modal: data.cboModal,
      reporte: this.idReport
    };
    if (this.filterEdit) {
      this.rfds.updateFilter(this.filterSelected.id, fil).then(resp => {
        if (resp) {
          this.loadfilters();
          this.closeForm();
        }
      });
    } else {
      this.rfds.cretateFilter(fil).then(resp => {
        if (resp) {
          this.loadfilters();
          this.closeForm();
        }
      });
    }
  }

  /**
   * Elimina una Filtro
   *
   * @private
   * @memberof ReportFilterComponent
   */
  private deleteFilter() {
    this.rfds.deleteFilter(this.filterSelected.id).then(() => {
      this.closeForm();
      this.loadfilters();
    }).catch(() => {
      this.closeForm();
    });
  }



  /**
   * Cierra la vista del formulario de creacion o edicion
   *
   * @memberof ReportFilterComponent
   */
  closeForm() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.filterEdit = false;
    this.filterSelected = null;
  }


  /**
   * Activa modal de confirmación
   *
   * @param {boolean} res
   * @memberof ReportFilterComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteFilter();
    }
    this.question = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/report-filter/report-filter.component.ts